import { render, staticRenderFns } from "./CarrierReason.vue?vue&type=template&id=b70ef204&scoped=true&"
import script from "./CarrierReason.vue?vue&type=script&lang=js&"
export * from "./CarrierReason.vue?vue&type=script&lang=js&"
import style0 from "./CarrierReason.vue?vue&type=style&index=0&id=b70ef204&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70ef204",
  null
  
)

export default component.exports